module.exports = {
      id: "close-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#close-icon",
      toString: function () {
        return this.url;
      }
    }